import { Menu as AntMenu } from 'antd'
import styled from 'styled-components'
import { space } from 'styled-system'

const Menu = styled(AntMenu)`
  ${space};
`

export default Menu